import "slick-carousel/slick/slick";

jQuery(document).ready(function () {

    var slidesToShowXXL;
    var slidesToShowLG;

    if(jQuery(".social-dm-media-slider").attr("data-items") <= 5){
        slidesToShowXXL = 3;
    } else {
        slidesToShowXXL = 5;
    }
    
    if (jQuery(".social-dm-media-slider").attr("data-items") <= 3){
        slidesToShowLG = 1;
    } else {
        slidesToShowLG = 3;
    }

    jQuery(".social-dm-media-slider").on('init', function(event, slick){
        if(jQuery(".social-dm-media-slider .slick-slide:not(.slick-cloned)").length <= 1){
            jQuery(".social-dm-media-sec .slick-arrow").addClass("hidden");
        }
    });

    jQuery(".social-dm-media-slider").slick({
        mobileFirst: true,
        slidesToShow: 1,
        centerMode: false,
        arrows: false,
        prevArrow: jQuery(".social__prev"),
        nextArrow: jQuery(".social__next"),
        dots: true,
        focusOnSelect: true,
        centerPadding: "25%",
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: slidesToShowLG,
                    centerPadding: "0",
                    arrows: true
                }
            },
            {
                breakpoint: 1400,
                settings: {
                    slidesToShow: slidesToShowXXL,
                    centerPadding: "0",
                    arrows: true
                }
            }
        ],
    });
});
